import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import '@/App.css';
import { CartProvider } from '@/lib/CartContext';
import { api, getSessionId } from '@/lib/api';

import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import AdminLayout from '@/components/layout/AdminLayout';
import WhatsAppButton from '@/components/WhatsAppButton';

import HomePage from '@/pages/HomePage';
import ProductListPage from '@/pages/ProductListPage';
import ProductDetailPage from '@/pages/ProductDetailPage';
import CartPage from '@/pages/CartPage';
import CheckoutPage from '@/pages/CheckoutPage';
import LocalesPage from '@/pages/LocalesPage';

import AdminLogin from '@/pages/admin/AdminLogin';
import AdminDashboard from '@/pages/admin/AdminDashboard';
import AdminProducts from '@/pages/admin/AdminProducts';
import AdminCategories from '@/pages/admin/AdminCategories';
import AdminSellers from '@/pages/admin/AdminSellers';
import AdminOrders from '@/pages/admin/AdminOrders';
import AdminSettings from '@/pages/admin/AdminSettings';
import AdminVisits from '@/pages/admin/AdminVisits';
import AdminLocales from '@/pages/admin/AdminLocales';

function VisitTracker() {
    const location = useLocation();
    useEffect(() => {
        if (location.pathname.startsWith('/admin')) return;
        api.post('/visits/track', {
            page: location.pathname + location.search,
            referrer: document.referrer,
            session_id: getSessionId(),
        }).catch(() => {});
    }, [location.pathname, location.search]);
    return null;
}

function StoreLayout({ children }) {
    return (
        <>
            <Header />
            <main className="min-h-[60vh]">{children}</main>
            <Footer />
        </>
    );
}

function App() {
    return (
        <CartProvider>
            <BrowserRouter>
                <VisitTracker />
                <WhatsAppButton />
                <Toaster position="top-right" richColors />
                <Routes>
                    {/* Store routes */}
                    <Route path="/" element={<StoreLayout><HomePage /></StoreLayout>} />
                    <Route path="/productos" element={<StoreLayout><ProductListPage /></StoreLayout>} />
                    <Route path="/productos/:slug" element={<StoreLayout><ProductDetailPage /></StoreLayout>} />
                    <Route path="/carrito" element={<StoreLayout><CartPage /></StoreLayout>} />
                    <Route path="/checkout" element={<StoreLayout><CheckoutPage /></StoreLayout>} />
                    <Route path="/locales" element={<StoreLayout><LocalesPage /></StoreLayout>} />

                    {/* Admin routes */}
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin" element={<AdminLayout />}>
                        <Route index element={<AdminDashboard />} />
                        <Route path="productos" element={<AdminProducts />} />
                        <Route path="categorias" element={<AdminCategories />} />
                        <Route path="pedidos" element={<AdminOrders />} />
                        <Route path="vendedores" element={<AdminSellers />} />
                        <Route path="visitas" element={<AdminVisits />} />
                        <Route path="locales" element={<AdminLocales />} />
                        <Route path="configuracion" element={<AdminSettings />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </CartProvider>
    );
}

export default App;
